import { Sparkles, Mail, Linkedin } from "lucide-react";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/[0.06] bg-[#04081a]"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue-400/40 to-transparent" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-8 items-start">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="relative w-9 h-9 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 grid place-items-center shadow-[0_0_20px_rgba(59,130,246,0.4)]">
                <Sparkles className="w-4 h-4 text-white" strokeWidth={2} />
              </span>
              <div>
                <div className="text-white font-medium" style={{ fontFamily: "Outfit" }}>
                  Joneten Saputra
                </div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-blue-400/80 font-mono-display">
                  Product · Solution
                </div>
              </div>
            </div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-sm">
              Product Manager &amp; Technical Solution Specialist — membantu pengembangan produk
              teknologi dari ide hingga delivery project.
            </p>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-blue-400 mb-4 font-mono-display">
              /// navigation
            </div>
            <div className="grid grid-cols-2 gap-2.5 text-sm">
              {["Home", "About", "Expertise", "Achievement", "Blog", "Freelance", "Contact"].map((n) => (
                <button
                  key={n}
                  onClick={() => document.getElementById(n.toLowerCase())?.scrollIntoView({ behavior: "smooth" })}
                  className="text-left text-slate-300 hover:text-blue-300 transition-colors"
                  data-testid={`footer-nav-${n.toLowerCase()}`}
                >
                  {n}
                </button>
              ))}
            </div>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-blue-400 mb-4 font-mono-display">
              /// connect
            </div>
            <div className="space-y-3">
              <a
                href="mailto:joneten91@gmail.com"
                data-testid="footer-email"
                className="flex items-center gap-2.5 text-sm text-slate-300 hover:text-blue-300 transition-colors"
              >
                <Mail className="w-4 h-4" strokeWidth={1.5} />
                joneten91@gmail.com
              </a>
              <a
                href="https://www.linkedin.com/in/joneten-saputra-913816105/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="flex items-center gap-2.5 text-sm text-slate-300 hover:text-blue-300 transition-colors"
              >
                <Linkedin className="w-4 h-4" strokeWidth={1.5} />
                LinkedIn
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/[0.05] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-slate-500 font-mono-display">
            © 2026 Joneten Saputra. Product Manager &amp; Technical Solution Specialist.
          </p>
          <p className="text-xs text-slate-500 font-mono-display">
            <span className="inline-flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-blink" />
              v1.0 · dark by design
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
